import { ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";
import { Settings } from "@credcore/core-ui/icons";

interface MainLayoutProps {
  children: ReactNode;
}

export function MainLayout({ children }: MainLayoutProps) {
  const location = useLocation();
  const isSettingsPage = location.pathname === "/settings";

  return (
    <div className="flex min-h-screen flex-col bg-gray-50">
      <header className="sticky top-0 z-50 border-b border-gray-200 bg-white">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="flex h-14 items-center justify-between">
            <Link
              to="/"
              className="text-lg font-semibold text-gray-900 hover:text-gray-700"
            >
              Evaluation Dashboard
            </Link>
            <Link
              to="/settings"
              className={`rounded-md p-2 transition-colors ${
                isSettingsPage
                  ? "bg-gray-100 text-gray-900"
                  : "text-gray-500 hover:bg-gray-100 hover:text-gray-700"
              }`}
              aria-label="Settings"
            >
              <Settings className="h-5 w-5" />
            </Link>
          </div>
        </div>
      </header>

      <main className="mx-auto w-full max-w-7xl flex-1 p-4 sm:p-6">
        {children}
      </main>
    </div>
  );
}
